module.exports = __webpack_public_path__ + "static/media/norecord.c825a9b7.png";